import { render, staticRenderFns } from "./WashScreen.vue?vue&type=template&id=29b06769&scoped=true&"
import script from "./WashScreen.vue?vue&type=script&lang=js&"
export * from "./WashScreen.vue?vue&type=script&lang=js&"
import style0 from "./WashScreen.vue?vue&type=style&index=0&id=29b06769&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b06769",
  null
  
)

export default component.exports